import { useHistory, useParams } from "react-router-dom";
import { useCurrentEntityId } from "hooks/useCurrentEntityId";
import {
  isStripeReconcileDetail,
  useGetAIReconcileDetailQuery,
} from "store/apis/reconciliation";
import { AIReconcileDetailModal } from "./AIReconcileDetailModal";
import { StripeReconciliationModal } from "./StripeReconciliationModal";

export const AIReconciliation = () => {
  const { reconcilationId } = useParams<{ reconcilationId: string }>();
  const entityId = useCurrentEntityId();
  const history = useHistory();
  const { data, isLoading } = useGetAIReconcileDetailQuery(
    { entityId, reconciliationStateId: reconcilationId },
    { skip: !entityId || !reconcilationId }
  );

  const handleClose = () => {
    history.goBack();
  };

  if (isLoading) {
    return null;
  }

  if (isStripeReconcileDetail(data)) {
    return (
      <StripeReconciliationModal
        isOpen
        onClose={handleClose}
        entityId={entityId}
        detail={data}
      />
    );
  }

  return (
    <AIReconcileDetailModal
      isOpen
      onClose={handleClose}
      entityId={entityId}
      reconciliationStateId={reconcilationId}
    />
  );
};
